import React, { useEffect } from "react";

import bwipjs from "bwip-js";
import { adicionaDigitos } from "./Utils/adicionaDigitos";


interface Props{
    codigo:string;
}

export const GuiaCode = ({codigo}:Props)=>{
    useEffect(() => {
        try {
          
          // The return value is the canvas element
          let canvas = bwipjs.toCanvas("mycanvas", {
            bcid: "interleaved2of5", // Barcode type interleaved2of5 code128
            text: codigo, // Text to encode
            scale: 1, // 3x scaling factor
            height: 20, // Bar height, in millimeters
            includetext: false, // Show human-readable text
            textxalign: "center", // Always good to set this
          });
        } catch (e) {
          // `e` may be a string or Error object
        }
       
      }, [codigo]);
      return (
        <div className="App" style={{display:"flex" ,alignItems:"center", justifyContent:"center", flexDirection:"column"}}>
        
          <canvas id="mycanvas"></canvas>
          {codigo.length == 44?<span>{adicionaDigitos(codigo)}</span>:"" }
          
        </div>
      );
   
}   